module.exports = __webpack_public_path__ + "static/media/landing-pastilles.f1286d51.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/landing-pastilles.jpg
// module id = 470
// module chunks = 0